import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '954491740742830';
/**
 * Meta Pixel — installs the FB tracking script on mount.
 * Wrapped in try/catch so any failure never breaks the page.
 * Renders nothing in the DOM.
 */
export function MetaPixel() {
  useEffect(() => {
    try {
      const w = window as any;
      // Idempotent: don't re-initialize if already loaded
      if (w.fbq) return;
      // Standard Meta Pixel base code (adapted for runtime injection)
      const fbq: any = function () {
        fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
      };
      w.fbq = fbq;
      if (!w._fbq) w._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
      w.fbq('init', PIXEL_ID);
      w.fbq('track', 'PageView');
    } catch (err) {
      // Silently fail — never break the page if pixel has issues
      console.warn('Meta Pixel failed to initialize:', err);
    }
  }, []);
  return null;
}